import { createSlice } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  GROUP_SUMMARY: [],
  totalCount: 0,
};

const slice = createSlice({
  name: "GROUP_SUMMARY",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getGroupSummaryList.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(
      Act.getGroupSummaryList.fulfilled,
      (state, { payload }) => ({
        ...state,
        loading: false,
        GROUP_SUMMARY: payload,
        totalCount: payload.total_record_count || 0,
      })
    );
    builder.addCase(Act.getGroupSummaryList.rejected, (state, action) => ({
      ...state,
      loading: false,
      GROUP_SUMMARY: [],
      totalCount: 0,
    }));
  },
});

export default slice;
